import { render, staticRenderFns } from "./DeliveryAndPayment.vue?vue&type=template&id=29f7e807&"
import script from "./DeliveryAndPayment.vue?vue&type=script&lang=js&"
export * from "./DeliveryAndPayment.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAndPayment.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports